import { render, staticRenderFns } from "./parent-payments.vue?vue&type=template&id=4c1dc298&scoped=true&"
import script from "./parent-payments.vue?vue&type=script&lang=js&"
export * from "./parent-payments.vue?vue&type=script&lang=js&"
import style0 from "./parent-payments.vue?vue&type=style&index=0&id=4c1dc298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VCard,VDataTable,VIcon,VImg,VSelect})
